// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.OutdoorImpact-module__messageContainer___TdiNx {
    display: grid; 
    place-items: center; 
    width: 100%;
    perspective: 1000px; 
    flex: 1; 
}

.OutdoorImpact-module__messageText____9sdv {
    font-size: 24px;
    color: #374151;
    text-align: center;
}

.OutdoorImpact-module__messageWithoutCard___xhWDr {
    padding: 2rem;
}

.OutdoorImpact-module__messageCard___agLBQ {
    padding: 2rem;
    background-color: #e5e7eb;
    border: 1px solid #e5e7eb;
    border-radius: 0.5rem;
    box-shadow: 
        0 10px 20px rgba(0, 0, 0, 0.1), 
        0 6px 6px rgba(0, 0, 0, 0.1), 
        0 0 100px rgba(0, 0, 0, 0.1);
    transform-style: preserve-3d;
    transition: transform 0.3s ease;
}

.OutdoorImpact-module__oiContainer___GvqnB {
    display: flex;
    justify-content: center;
    margin-top: 10vh;
    width: 100%;
}

.OutdoorImpact-module__contentWrapper___n0sVa {
    border: 1px solid #d4d4d4;
    padding: 16px;
    margin-bottom: 20px;
    background: white;
    box-shadow: 
        0 8px 16px rgba(0, 0, 0, 0.1), 
        0 16px 32px rgba(0, 0, 0, 0.05);
    width: fit-content;
    transform: perspective(1000px) translateZ(0);
    transition: transform 0.3s ease;
}

.OutdoorImpact-module__oiTable___F8V3o {
    width: auto;
    border-collapse: collapse;
    table-layout: auto;
    border: 1px solid #d4d4d4;
    box-shadow: 
        0 4px 8px rgba(0, 0, 0, 0.1), 
        0 2px 4px rgba(0, 0, 0, 0.05);
    background-color: white;
}

/* Optional modifier to force full width and height in specific components */
.OutdoorImpact-module__oiTableFullWidthHeight___rbBwn {
    width: 100%;
    height: 100%;
}

.OutdoorImpact-module__oiTableAspectRatio___a_Xrr {

    @media (min-aspect-ratio: 2) {
        aspect-ratio: 5/1.8;
    }

    /* Handle very high zoom levels (like 175%) or narrow screens */
    @media (max-width: 1600px) and (min-width: 700px) {
        aspect-ratio: 5 / 2.4;
    }
}

.OutdoorImpact-module__oiTableAspectRatioWithFootNote___jtMX3 {

    @media (min-aspect-ratio: 2) {
        aspect-ratio: 5/2;
    }

    /* Handle very high zoom levels (like 175%) or narrow screens */
    @media (max-width: 1600px) and (min-width: 700px) {
        aspect-ratio: 5 / 2.2;
    }
}

    .OutdoorImpact-module__oiTable___F8V3o th {
        background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);
        border: 1px solid #d4d4d4;
        padding: 8px 12px;
        text-align: center;
        font-weight: 600;
        color: #333;
        white-space: nowrap;
        position: relative;
    }

        .OutdoorImpact-module__oiTable___F8V3o th:hover {
            background: linear-gradient(180deg, #e9ecef 0%, #dee2e6 100%);
        }

        .OutdoorImpact-module__oiTable___F8V3o td {
            border: 1px solid #e0e0e0;
            padding: 6px 12px;
            text-align: right; /* Excel typically right-aligns numbers */

            /* Handle very high zoom levels (like 175%) or narrow screens */
            @media (max-width: 1600px) and (min-width: 700px) {
                padding: 0 6px 0 12px;;
            }
        }

        /* Text columns should be left-aligned */
        .OutdoorImpact-module__oiTable___F8V3o td:first-child {
            text-align: left;
        }

    .OutdoorImpact-module__oiTable___F8V3o tbody tr:nth-child(even) {
        background-color: #fafafa;
    }

    .OutdoorImpact-module__oiTable___F8V3o tbody tr:hover {
        background-color: #f0f7ff;
    }

    /* Excel-like selection color */
    .OutdoorImpact-module__oiTable___F8V3o td.OutdoorImpact-module__selected___zUlCX {
        background-color: #e6f3ff;
        outline: 2px solid #0077e6;
        position: relative;
    }

.OutdoorImpact-module__extraData___kMiwT {
    font-weight: 500;
    color: #444;
}

/* Column header divider line (Excel-like) */
.OutdoorImpact-module__oiTable___F8V3o th:not(:last-child)::after {
    content: '';
    position: absolute;
    right: 0;
    top: 25%;
    height: 50%;
    width: 1px;
    background-color: #d4d4d4;
}

.OutdoorImpact-module__footerNote___dkFaw {
    color: #666;
    font-size: 0.9em;
    margin: 4px 0;
}

.OutdoorImpact-module__exportIDSResultButton___nMDg6,
.OutdoorImpact-module__exportSpotplanButton___e4oDC,
.OutdoorImpact-module__exportFaceIdButton___kpXyc {
    color: white;
    padding: 8px 16px;
    border: 0px;
    border-radius: 8px;
    transition: background-color 0.3s ease;
    font-weight: 800;
    cursor: pointer;
    width: 170px;
    box-shadow: 
        0 10px 20px rgba(0, 0, 0, 0.1), 
        0 6px 6px rgba(0, 0, 0, 0.1), 
        0 0 100px rgba(0, 0, 0, 0.1);
}

    .OutdoorImpact-module__exportIDSResultButton___nMDg6:hover {
        background-color: darkgray;
    }
    
    .OutdoorImpact-module__exportSpotplanButton___e4oDC:hover,
    .OutdoorImpact-module__exportFaceIdButton___kpXyc:hover {
        background-color: var(--bmo-primary-color-mint-dark);
    }

.OutdoorImpact-module__containerExportIDSResultButton___l3x9y {
    margin-bottom: 16px;
}

.OutdoorImpact-module__containerExportFaceIdButton___F3Tbd,
.OutdoorImpact-module__containerExportSpotplanButton___TVM8Y {
    display: flex;
    justify-content: flex-end;
    margin: 10px 0;
}

.OutdoorImpact-module__exportIDSResultButton___nMDg6 {
    background-color: black;
}

.OutdoorImpact-module__exportSpotplanButton___e4oDC,
.OutdoorImpact-module__exportFaceIdButton___kpXyc {
    background-color: var(--bmo-primary-color-mint);

}`, "",{"version":3,"sources":["webpack://./app/components/ProofOfDeliveryLayout/OutdoorImpact/OutdoorImpact.module.css"],"names":[],"mappings":";AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,yBAAyB;IACzB,qBAAqB;IACrB;;;oCAGgC;IAChC,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB;;uCAEmC;IACnC,kBAAkB;IAClB,4CAA4C;IAC5C,+BAA+B;AACnC;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB;;qCAEiC;IACjC,uBAAuB;AAC3B;;AAEA,4EAA4E;AAC5E;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI;QACI,mBAAmB;IACvB;;IAEA,+DAA+D;IAC/D;QACI,qBAAqB;IACzB;AACJ;;AAEA;;IAEI;QACI,iBAAiB;IACrB;;IAEA,+DAA+D;IAC/D;QACI,qBAAqB;IACzB;AACJ;;IAEI;QACI,6DAA6D;QAC7D,yBAAyB;QACzB,iBAAiB;QACjB,kBAAkB;QAClB,gBAAgB;QAChB,WAAW;QACX,mBAAmB;QACnB,kBAAkB;IACtB;;QAEI;YACI,6DAA6D;QACjE;;QAEA;YACI,yBAAyB;YACzB,iBAAiB;YACjB,iBAAiB,EAAE,yCAAyC;;YAE5D,+DAA+D;YAC/D;gBACI,qBAAqB;YACzB;QACJ;;QAEA,wCAAwC;QACxC;YACI,gBAAgB;QACpB;;IAEJ;QACI,yBAAyB;IAC7B;;IAEA;QACI,yBAAyB;IAC7B;;IAEA,+BAA+B;IAC/B;QACI,yBAAyB;QACzB,0BAA0B;QAC1B,kBAAkB;IACtB;;AAEJ;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA,4CAA4C;AAC5C;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,WAAW;IACX,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;AACjB;;AAEA;;;IAGI,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,sCAAsC;IACtC,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ;;;oCAGgC;AACpC;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;;QAEI,oDAAoD;IACxD;;AAEJ;IACI,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,+CAA+C;;AAEnD","sourcesContent":["\n.messageContainer {\n    display: grid; \n    place-items: center; \n    width: 100%;\n    perspective: 1000px; \n    flex: 1; \n}\n\n.messageText {\n    font-size: 24px;\n    color: #374151;\n    text-align: center;\n}\n\n.messageWithoutCard {\n    padding: 2rem;\n}\n\n.messageCard {\n    padding: 2rem;\n    background-color: #e5e7eb;\n    border: 1px solid #e5e7eb;\n    border-radius: 0.5rem;\n    box-shadow: \n        0 10px 20px rgba(0, 0, 0, 0.1), \n        0 6px 6px rgba(0, 0, 0, 0.1), \n        0 0 100px rgba(0, 0, 0, 0.1);\n    transform-style: preserve-3d;\n    transition: transform 0.3s ease;\n}\n\n.oiContainer {\n    display: flex;\n    justify-content: center;\n    margin-top: 10vh;\n    width: 100%;\n}\n\n.contentWrapper {\n    border: 1px solid #d4d4d4;\n    padding: 16px;\n    margin-bottom: 20px;\n    background: white;\n    box-shadow: \n        0 8px 16px rgba(0, 0, 0, 0.1), \n        0 16px 32px rgba(0, 0, 0, 0.05);\n    width: fit-content;\n    transform: perspective(1000px) translateZ(0);\n    transition: transform 0.3s ease;\n}\n\n.oiTable {\n    width: auto;\n    border-collapse: collapse;\n    table-layout: auto;\n    border: 1px solid #d4d4d4;\n    box-shadow: \n        0 4px 8px rgba(0, 0, 0, 0.1), \n        0 2px 4px rgba(0, 0, 0, 0.05);\n    background-color: white;\n}\n\n/* Optional modifier to force full width and height in specific components */\n.oiTableFullWidthHeight {\n    width: 100%;\n    height: 100%;\n}\n\n.oiTableAspectRatio {\n\n    @media (min-aspect-ratio: 2) {\n        aspect-ratio: 5/1.8;\n    }\n\n    /* Handle very high zoom levels (like 175%) or narrow screens */\n    @media (max-width: 1600px) and (min-width: 700px) {\n        aspect-ratio: 5 / 2.4;\n    }\n}\n\n.oiTableAspectRatioWithFootNote {\n\n    @media (min-aspect-ratio: 2) {\n        aspect-ratio: 5/2;\n    }\n\n    /* Handle very high zoom levels (like 175%) or narrow screens */\n    @media (max-width: 1600px) and (min-width: 700px) {\n        aspect-ratio: 5 / 2.2;\n    }\n}\n\n    .oiTable th {\n        background: linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%);\n        border: 1px solid #d4d4d4;\n        padding: 8px 12px;\n        text-align: center;\n        font-weight: 600;\n        color: #333;\n        white-space: nowrap;\n        position: relative;\n    }\n\n        .oiTable th:hover {\n            background: linear-gradient(180deg, #e9ecef 0%, #dee2e6 100%);\n        }\n\n        .oiTable td {\n            border: 1px solid #e0e0e0;\n            padding: 6px 12px;\n            text-align: right; /* Excel typically right-aligns numbers */\n\n            /* Handle very high zoom levels (like 175%) or narrow screens */\n            @media (max-width: 1600px) and (min-width: 700px) {\n                padding: 0 6px 0 12px;;\n            }\n        }\n\n        /* Text columns should be left-aligned */\n        .oiTable td:first-child {\n            text-align: left;\n        }\n\n    .oiTable tbody tr:nth-child(even) {\n        background-color: #fafafa;\n    }\n\n    .oiTable tbody tr:hover {\n        background-color: #f0f7ff;\n    }\n\n    /* Excel-like selection color */\n    .oiTable td.selected {\n        background-color: #e6f3ff;\n        outline: 2px solid #0077e6;\n        position: relative;\n    }\n\n.extraData {\n    font-weight: 500;\n    color: #444;\n}\n\n/* Column header divider line (Excel-like) */\n.oiTable th:not(:last-child)::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 25%;\n    height: 50%;\n    width: 1px;\n    background-color: #d4d4d4;\n}\n\n.footerNote {\n    color: #666;\n    font-size: 0.9em;\n    margin: 4px 0;\n}\n\n.exportIDSResultButton,\n.exportSpotplanButton,\n.exportFaceIdButton {\n    color: white;\n    padding: 8px 16px;\n    border: 0px;\n    border-radius: 8px;\n    transition: background-color 0.3s ease;\n    font-weight: 800;\n    cursor: pointer;\n    width: 170px;\n    box-shadow: \n        0 10px 20px rgba(0, 0, 0, 0.1), \n        0 6px 6px rgba(0, 0, 0, 0.1), \n        0 0 100px rgba(0, 0, 0, 0.1);\n}\n\n    .exportIDSResultButton:hover {\n        background-color: darkgray;\n    }\n    \n    .exportSpotplanButton:hover,\n    .exportFaceIdButton:hover {\n        background-color: var(--bmo-primary-color-mint-dark);\n    }\n\n.containerExportIDSResultButton {\n    margin-bottom: 16px;\n}\n\n.containerExportFaceIdButton,\n.containerExportSpotplanButton {\n    display: flex;\n    justify-content: flex-end;\n    margin: 10px 0;\n}\n\n.exportIDSResultButton {\n    background-color: black;\n}\n\n.exportSpotplanButton,\n.exportFaceIdButton {\n    background-color: var(--bmo-primary-color-mint);\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageContainer": `OutdoorImpact-module__messageContainer___TdiNx`,
	"messageText": `OutdoorImpact-module__messageText____9sdv`,
	"messageWithoutCard": `OutdoorImpact-module__messageWithoutCard___xhWDr`,
	"messageCard": `OutdoorImpact-module__messageCard___agLBQ`,
	"oiContainer": `OutdoorImpact-module__oiContainer___GvqnB`,
	"contentWrapper": `OutdoorImpact-module__contentWrapper___n0sVa`,
	"oiTable": `OutdoorImpact-module__oiTable___F8V3o`,
	"oiTableFullWidthHeight": `OutdoorImpact-module__oiTableFullWidthHeight___rbBwn`,
	"oiTableAspectRatio": `OutdoorImpact-module__oiTableAspectRatio___a_Xrr`,
	"oiTableAspectRatioWithFootNote": `OutdoorImpact-module__oiTableAspectRatioWithFootNote___jtMX3`,
	"selected": `OutdoorImpact-module__selected___zUlCX`,
	"extraData": `OutdoorImpact-module__extraData___kMiwT`,
	"footerNote": `OutdoorImpact-module__footerNote___dkFaw`,
	"exportIDSResultButton": `OutdoorImpact-module__exportIDSResultButton___nMDg6`,
	"exportSpotplanButton": `OutdoorImpact-module__exportSpotplanButton___e4oDC`,
	"exportFaceIdButton": `OutdoorImpact-module__exportFaceIdButton___kpXyc`,
	"containerExportIDSResultButton": `OutdoorImpact-module__containerExportIDSResultButton___l3x9y`,
	"containerExportFaceIdButton": `OutdoorImpact-module__containerExportFaceIdButton___F3Tbd`,
	"containerExportSpotplanButton": `OutdoorImpact-module__containerExportSpotplanButton___TVM8Y`
};
export default ___CSS_LOADER_EXPORT___;
